import type { FC } from 'react';

import FormLabel from '../FormLabel';
import FormNumberInput from '../FormNumberInput';
import FormTemperatureUnitSelect from '../FormTemperatureUnitSelect';

interface Props {
  autoFocus?: boolean;
  className?: string;
  hideErrorMessage?: boolean;
  isDisabled?: boolean;
  isRequired?: boolean;
  label?: string;
  name: string;
}

const FormTemperatureInput: FC<Props> = ({ autoFocus, className, hideErrorMessage, isDisabled, isRequired, label, name }) => {
  return (
    <div className={className}>
      <FormLabel label={label} name={`${name}.value`} />
      <div className="flex flex-row space-x-1 whitespace-nowrap">
        <FormNumberInput
          autoFocus={autoFocus}
          className="flex-1 min-w-20"
          disabled={isDisabled}
          hideErrorMessage={hideErrorMessage}
          hideLabel={true}
          isRequired={isRequired}
          name={`${name}.value`}
          placeholder="0"
          step="any"
        />
        <FormTemperatureUnitSelect
          className="w-24"
          hideErrorMessage={hideErrorMessage}
          hideLabel={true}
          isDisabled={isDisabled}
          isRequired={isRequired}
          name={`${name}.unit`}
          renderMenuInPortal={true}
        />
      </div>
    </div>
  );
};

export type { Props as FormTemperatureInputProps };
export default FormTemperatureInput;
